import React from 'react'
import { FormattedMessage } from 'react-intl'

import AdminActionButton from '../admin-action/AdminActionButton'
import { AdminActionEnum } from '../admin-action/utils/admin-action-data'
import PingPongButton from '../../buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../utils/ping-pong-button-type.enum.ts'
import { IProposalInteractionsProps } from '../../../Proposal'

interface IUserWaitingHostAdjustmentsConfirmationFooterProps {
  adminActions: IProposalInteractionsProps['adminActions']
  clientProposalId: string
}

const UserWaitingHostAdjustmentsConfirmationFooter = ({
  adminActions,
  clientProposalId,
}: IUserWaitingHostAdjustmentsConfirmationFooterProps) => {
  const adminCanceledAdjustmentsConfirmation =
    adminActions?.adminCanceledAdjustmentsConfirmation

  return (
    <div className='flex w-full flex-col gap-3 py-5'>
      <PingPongButton
        label={
          <FormattedMessage
            id='ui.userCurrentActionButton.waitingHostAdjustmentsConfirmation'
            defaultMessage="Attente de confirmation de l'hôte"
          />
        }
        type={PingPongButtonTypeEnum.WAITING}
      />
      {adminCanceledAdjustmentsConfirmation && (
        <AdminActionButton
          adminAction={AdminActionEnum.CANCEL_ADJUSTMENTS_CONFIRMATION}
          onClickConfirm={() =>
            adminCanceledAdjustmentsConfirmation.callback({ clientProposalId })
          }
          isLoading={adminCanceledAdjustmentsConfirmation.isLoading}
        />
      )}
    </div>
  )
}

export default UserWaitingHostAdjustmentsConfirmationFooter
